// extracted by mini-css-extract-plugin
export default {"imageBoxContainer":"BlockImage_imageBoxContainer__LhwnU"};